const IMAGE_DPI = 37;
// let dragStartX,dragStartY,dragOffsetX = 0,dragOffsetY = 0;
let finalImagePreview; // Variable to store the final image preview
let appState = []; // Global state to hold all input configurations
let klassikMattPriceGroup = klassikMattPricesGroupObj;
let deluxGlassopticPriceGroup = deluxeGlasoptikPricesGroupObj;
let cropperInstance = null;
let savedCropData = {};
let imageAreaPopupImage = document.querySelector('.config-main-product #popup-image');
// let draggableArea = document.querySelector('.config-main-product #draggable-area');
let imageAreapopup = document.querySelector('.config-main-product #resizeModalWindow');
let configBackBtn = document.querySelectorAll('.config-main-product [data-back-button]');
let defaultCropMap = {};
// defaultCropMap[index] = null;



const priceFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: `${Shopify.currency.active}`
});


document.addEventListener('DOMContentLoaded', () => {
  
  const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
  initContainer(configContainers);
  handleAdditionalProdRadio();
  setMobileSliderActiveSlideHieght();

  // if(draggableArea){
  //   draggableArea.addEventListener("mousedown", (e) => {
  //     dragStartX = e.clientX - draggableArea.offsetLeft;
  //     dragStartY = e.clientY - draggableArea.offsetTop;
  //     document.addEventListener("mousemove", dragMove);
  //     document.addEventListener("mouseup", dragStop);
  //   });
  // }

  const applyButton = document.querySelector('.config-main-product #applyButton');

  if (applyButton) {
    applyButton.addEventListener("click", () => {

      if (!cropperInstance) {
        console.warn("Cropper not initialized");
        return;
      }

      const activeInput = document.querySelector('[data-dimensions-input].active-input');

      if (!activeInput) {
        console.warn("No active input found");
        return;
      }

      const index = activeInput.dataset.index ?? 0;

      const croppedCanvas = cropperInstance.getCroppedCanvas({
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });

      if (!croppedCanvas) {
        console.error("Failed to get cropped canvas");
        return;
      }

      const croppedImageDataURL = croppedCanvas.toDataURL("image/png");

      const cropData = cropperInstance.getData(true);

      if (!cropData) {
        console.error("No crop data available");
        return;
      }

      const roundedCrop = {
        x: Math.round(cropData.x),
        y: Math.round(cropData.y),
        width: Math.round(cropData.width),
        height: Math.round(cropData.height)
      };

      savedCropData[index] = roundedCrop;
      syncHiddenProperties();

      if (!imageAreaPopupImage) {
        console.warn("Popup image not found");
        return;
      }

      const frontendWidth  = imageAreaPopupImage.naturalWidth;
      const frontendHeight = imageAreaPopupImage.naturalHeight;

      const frontendWidthInput  = document.querySelector('input[name="properties[_frontend_width]"]');
      const frontendHeightInput = document.querySelector('input[name="properties[_frontend_height]"]');

      if (frontendWidthInput)  frontendWidthInput.value  = frontendWidth;
      if (frontendHeightInput) frontendHeightInput.value = frontendHeight;

      const cropXInput      = document.querySelector('input[name="properties[_crop_x]"]');
      const cropYInput      = document.querySelector('input[name="properties[_crop_y]"]');
      const cropWidthInput  = document.querySelector('input[name="properties[_crop_width]"]');
      const cropHeightInput = document.querySelector('input[name="properties[_crop_height]"]');

      if (cropXInput) {
        cropXInput.value      = roundedCrop.x;
        cropYInput.value      = roundedCrop.y;
        cropWidthInput.value  = roundedCrop.width;
        cropHeightInput.value = roundedCrop.height;
      }

      if (typeof updatePrintProperties === "function") {
        updatePrintProperties(index);
      } else {
        console.warn("updatePrintProperties function missing");
      }

      if (imageAreapopup) {
        imageAreapopup.classList.add('hidden');
      }

      cropperInstance.destroy();
      cropperInstance = null;

      const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");

      configContainers.forEach((container) => {

        const canvas = container.querySelector(
          `.cropped-image-wrap[data-canvas-index="${index}"] canvas`
        );

        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        canvas.width  = croppedCanvas.width;
        canvas.height = croppedCanvas.height;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(croppedCanvas, 0, 0);
      });
      localStorage.setItem('manual_cropping_status',true);
    });
  } else {
    console.warn("#applyButton not found in DOM");
  }

  
  if(document.querySelector('.config-main-product #cancelButton')){
    document.querySelector('.config-main-product #cancelButton').addEventListener("click", () => {
      imageAreapopup.classList.add('hidden');
      if(configContainers.length){
        configContainers.forEach((container, index) => {
          const canvas = container.querySelector('.cropped-image-wrap.active .cropped-image');
          if (!canvas) return;

          const inputBox = container.querySelector(
            `[data-dimensions-input][data-index="${index}"]`
          );
          if (!inputBox) return;

          const cropWidthCm  = parseFloat(inputBox.querySelector('.crop-width').value);
          const cropHeightCm = parseFloat(inputBox.querySelector('.crop-height').value);

          cropImage(
            canvas,
            cropWidthCm,
            cropHeightCm,
            container,
            index
          );
        });
      }
    });
  }

  if (window.matchMedia('(min-width: 991px)').matches) {
    activeStep();
    window.addEventListener('scroll', (e) => handleScrollEvent(e));
  }

  const mediaQuery = window.matchMedia("(max-width: 989px)");
  // Listen for changes
  mediaQuery.addEventListener("change", function(){
    location.reload();
  });

});


function setMobileSliderActiveSlideHieght() {
  //config pdp slide height logic
  setTimeout(() => {
    if(document.querySelector('.mobile-layout-wrapper .step-slide.active-slide')){
      let currentHeight = document.querySelector('.mobile-layout-wrapper .step-slide.active-slide').offsetHeight;
      if(document.querySelector('.mobile-layout-wrapper .configure-mobile-slider')){
        window.requestAnimationFrame(() => {
          document.querySelector('.mobile-layout-wrapper .configure-mobile-slider').style.height = `${currentHeight}px`;
        });
      }
    }

    //update swiper instaces for re-calculate slider height
    document.querySelector(`[data-mobile-config-slider]`)?.swiper?.update();
  },200);
}
function isCropChanged(current, original) {
  if (!current || !original) return false;

  const tolerance = 2;

  return (
    Math.abs(current.x - original.x) > tolerance ||
    Math.abs(current.y - original.y) > tolerance ||
    Math.abs(current.width - original.width) > tolerance ||
    Math.abs(current.height - original.height) > tolerance
  );
}

function showResetPopup(onConfirm) {
  const popup = document.getElementById('reset-warning-popup');
  const confirmBtn = document.getElementById('confirmReset');
  const cancelBtn = document.getElementById('cancelReset');

  popup.classList.remove('hidden');

  const handleConfirm = () => {
    popup.classList.add('hidden');
    cleanup();
    onConfirm();
  };

  const handleCancel = () => {
    popup.classList.add('hidden');
    cleanup();
  };

  function cleanup() {
    confirmBtn.removeEventListener('click', handleConfirm);
    cancelBtn.removeEventListener('click', handleCancel);
  }

  confirmBtn.addEventListener('click', handleConfirm);
  cancelBtn.addEventListener('click', handleCancel);
}

function showAutoPopup(message, onClose, showActions = false) {
  const popup = document.getElementById('reset-warning-popup');
  const messageBox = popup.querySelector('p');

  // change message dynamically
  messageBox.innerHTML = message;

  popup.classList.remove('hidden');

  // hide buttons (important for auto popup)
  const actions = popup.querySelector('.reset-warning-actions');
  if (actions)  actions.style.display = showActions ? 'flex' : 'none';

  // setTimeout(() => {
  //   popup.classList.add('hidden');

  //   // restore buttons for future use
  //   if (actions) actions.style.display = 'flex';

  //   if (typeof onClose === "function") {
  //     onClose();
  //   }

  // }, 5000);
}

const popup = document.getElementById('reset-warning-popup');
const overlay = popup?.querySelector('.reset-warning-overlay');

const closePopupBtn = document.querySelector('.close-waring-popup-btn');
if (overlay) {
  overlay.addEventListener('click', () => {
    popup.classList.add('hidden');
  });
}
closePopupBtn.addEventListener('click', () => {
  popup.classList.add('hidden');
});

function toggleChangeAreaButton(container) {
  const changeAreaBtn = container.querySelector('.change-area-btn');

  if (!changeAreaBtn) return;

  if (appState.length >= 2) {
    changeAreaBtn.classList.add('disabled');
  } else {
    changeAreaBtn.classList.remove('disabled');
  }
}

function initContainer(configContainers) {
  if (configContainers.length) {
    configContainers.forEach(container => {
      const savedState = sessionStorage.getItem('appState');
      if (savedState) {
        appState = JSON.parse(savedState);
      } else {
        appState = [{ height: 40, width: 50 }]; // Initialize state with a single default input
      }

      loadInputsFromState(container);
      toggleChangeAreaButton(container);

      syncHiddenProperties();


      let changeAreaButton = container.querySelector(`.change-area-btn`);
      if(changeAreaButton){
        changeAreaButton.addEventListener("click", () => {

          //  BLOCK if 2 pieces
          if (appState.length >= 2) {

            showAutoPopup(
              `Ausschnitt ändern nur bei einer (1) Rückwand gleichzeitig möglich.<br><br>
              Füge bitte zuerst ein Stück zum Warenkorb hinzu, und konfiguriere danach das nächste Stück.`,
              null,
              false
            );
              
            return; 
          }

          if (!imageAreapopup) return;

          const activeInput = container.querySelector('[data-dimensions-input].active-input');
          if (!activeInput) return;

          const productSourceImg = container.querySelector(".source-image");
          imageAreaPopupImage.src = productSourceImg.src;

          imageAreapopup.classList.remove('hidden');

          const cropWidthCm  = parseFloat(activeInput.querySelector(".crop-width").value);
          const cropHeightCm = parseFloat(activeInput.querySelector(".crop-height").value);

          imageAreaPopupImage.onload = function () {

            if (cropperInstance) {
              cropperInstance.destroy();
            }

            const aspectRatio = cropWidthCm / cropHeightCm;

            cropperInstance = new Cropper(imageAreaPopupImage, {
              aspectRatio: aspectRatio,
              viewMode: 1,
              autoCropArea: 1,
              responsive: true,
              background: false,
              ready() {
                const activeInput = container.querySelector('[data-dimensions-input].active-input');
                const index = activeInput?.dataset.index ?? 0;
                syncPopupWithMain(index);
                defaultCropMap[index] = cropperInstance.getData(true);
              }
            });

          };

        });

      }

      // We only need to listen for input on the desktop or mobile container
      // The shared logic in handleInputChange will sync all inputs
      // const dimensionContainers = container.querySelectorAll(".config-dimensions-input-wrapper");
      // if (dimensionContainers.length) {
      //   dimensionContainers.forEach(wrapper => {
      //     wrapper.addEventListener('input', (event) => {
      //       const input = event.target;
      //       const closestInputBox = input.closest('[data-dimensions-input]');
      //       if (closestInputBox) {
      //         const index = Array.from(wrapper.querySelectorAll('[data-dimensions-input]')).indexOf(closestInputBox);
      //         if (index !== -1) {
      //           if (input.classList.contains('crop-width')) {
      //             handleInputChange(input.value, 'width', index, container);
      //           } else if (input.classList.contains('crop-height')) {
      //             handleInputChange(input.value, 'height', index, container);
      //           }
      //         }
      //       }
      //     });
      //   });
      // }

      // Add more configure input box
      const addMoreConfigProBtn = container.querySelectorAll('#addMoreConfigPro');
      if (addMoreConfigProBtn.length) {
        addMoreConfigProBtn.forEach(btn => {
          btn.addEventListener('click', (e) => {

            e.preventDefault();

            const activeInput = container.querySelector('[data-dimensions-input].active-input');
            const index = activeInput?.dataset.index ?? 0;

            const currentCrop = savedCropData[index];
            const defaultCrop = defaultCropMap[index];

            const changed = isCropChanged(currentCrop, defaultCrop);

            //  CASE: CROP CHANGED
            if (changed) {

            if(appState.length == 1){
               showAutoPopup(
                `Du hast den Bildausschnitt angepasst. Beim Hinzufügen eines weiteren Stücks wird er zurückgesetzt.<br><br>
                Füge bitte zuerst ein Stück zum Warenkorb hinzu, und konfiguriere danach das nächste Stück.`,
                null,
                true // ✅ show buttons
              );
            }
           
         

              showResetPopup(() => {
                //  Continue clicked

                // 1. reset crop
                delete savedCropData[index];

                const canvas = container.querySelector(
                  `.cropped-image-wrap[data-canvas-index="${index}"] canvas`
                );

                if (canvas && appState[index]) {
                  cropImage(
                    canvas,
                    appState[index].width,
                    appState[index].height,
                    container,
                    index
                  );
                }

                // 2. ADD NEW PIECE (only here)
                if (appState.length < 5) {
                  appState.push({ height: 40, width: 50 });
                  saveState();
                  loadInputsFromState(container);
                  toggleChangeAreaButton(container);
                  setMobileSliderActiveSlideHieght();
                  handleDataLayer(appState.length - 1,'update');
                  syncHiddenProperties();
                }

              });

              return; // 🚨 VERY IMPORTANT (STOP HERE)
            }

            // 🟢 CASE: NO CHANGE → normal add
            if (appState.length < 5) {
              appState.push({ height: 40, width: 50 });
              saveState();
              loadInputsFromState(container);
              toggleChangeAreaButton(container);
              setMobileSliderActiveSlideHieght();
              handleDataLayer(appState.length - 1,'update');
              syncHiddenProperties();
            }

          });

          // btn.addEventListener('click', (e) => {
          //   e.preventDefault();
          //   const target = e.target;
          //   const closestEle = target.closest(`.config-dimensions-input-wrapper`);
          //   if (appState.length < 5) {
          //     // Add a new default object to the state
          //     appState.push({ height: 40, width: 50 });
          //     saveState();
          //     loadInputsFromState(container);
          //     setMobileSliderActiveSlideHieght();
          //     // Update DataLayer
          //     handleDataLayer(appState.length - 1,'update');
          //   }
          // });

        });

        container.addEventListener('click', (event) => {

          if (event.target.closest('.remove-button')) {
            // Event delegation for the "Remove Configure Input Box" buttons
            const elementToRemove = event.target.closest('[data-dimensions-input]');
            if (elementToRemove) {
              const wrapper = elementToRemove.closest(`.config-dimensions-input-wrapper`);
              const index = Array.from(wrapper.querySelectorAll('[data-dimensions-input]')).indexOf(elementToRemove);
              if (index !== -1) {
                appState.splice(index, 1);
                saveState();
                loadInputsFromState(container);
                toggleChangeAreaButton(container);
                setMobileSliderActiveSlideHieght();
                delete savedCropData[index];
                const newCrop = {};
                appState.forEach((_, i) => {
                  newCrop[i] = savedCropData[i] || null;
                });
                savedCropData = newCrop;

                syncHiddenProperties();
                 // Update DataLayer
                handleDataLayer(index, 'remove');
                function normalizeState() {
                  appState = appState.map(item => item);

                  const newCrop = {};
                  appState.forEach((_, i) => {
                    newCrop[i] = savedCropData[i] || null;
                  });

                  savedCropData = newCrop;
                }
              }
            }
          }else{
            // Set active input box with relevant canvas
            if (event.target.closest('[data-dimensions-input]')) {
              const closestEle = event.target.closest('[data-dimensions-input]');
              if(!closestEle.classList.contains(`active-input`)){
                const allInputEle = container.querySelectorAll(`[data-dimensions-input]`);
                if(allInputEle.length){
                  allInputEle.forEach(ele => ele.classList.remove(`active-input`));
                  closestEle.classList.add(`active-input`);
                  setCanvasActiveClass(container);
                }
              }
            }
          }
          const canvasWrapper = event.target.closest('.cropped-image-wrap');
          if (canvasWrapper && container.contains(canvasWrapper)) {

            const index = canvasWrapper.dataset.canvasIndex;
            if (index === undefined) return;

            // Remove active-input from all inputs
            const allInputs = container.querySelectorAll('[data-dimensions-input]');
            allInputs.forEach(ele => ele.classList.remove('active-input'));

            // Activate matching input
            const matchingInput = container.querySelector(
              `[data-dimensions-input][data-index="${index}"]`
            );

            if (matchingInput) {
              matchingInput.classList.add('active-input');
              setCanvasActiveClass(container);
              updatePrintProperties(index);
            }

            return; // prevent falling into other click logic
          }
        });
      }
    });
  }
}

function getActiveIndex() {
  const active = document.querySelector(
    '.desktop-layout-wrapper [data-dimensions-input].active-input, \
     .mobile-layout-wrapper [data-dimensions-input].active-input'
  );
  return active ? Number(active.dataset.index) : 0;
}

document.addEventListener('input', (event) => {
  const input = event.target;

  if (!input.classList.contains('crop-width') && !input.classList.contains('crop-height')) return;
  localStorage.setItem('manual_cropping_status',false);
  
  const inputBox = input.closest('[data-dimensions-input]');
  if (!inputBox) return;

  var index = Number(inputBox.dataset.index ?? 0);

  const container = input.closest('.desktop-layout-wrapper, .mobile-layout-wrapper');

  const isPopup = !container;

  let targetContainer;

  if (isPopup) {
    index = getActiveIndex();
    // fallback to active container
    targetContainer = document.querySelector('.desktop-layout-wrapper, .mobile-layout-wrapper');
  } else {
    targetContainer = container;
  }

  if (!targetContainer) return;

  if (input.classList.contains('crop-width')) {
    handleInputChange(input.value, 'width', index, targetContainer);
  }

  if (input.classList.contains('crop-height')) {
    handleInputChange(input.value, 'height', index, targetContainer);
  }

  syncPopupWithMain(index);
});

function syncPopupWithMain(index) {
  const popup = document.querySelector('#resizeModalWindow');
  if (!popup || popup.classList.contains('hidden')) return;

  const state = appState[index];
  if (!state) return;

  const popupHeight = popup.querySelector('.crop-height');
  const popupWidth  = popup.querySelector('.crop-width');

  if (popupHeight && document.activeElement !== popupHeight) {
    popupHeight.value = state.height;
  }

  if (popupWidth && document.activeElement !== popupWidth) {
    popupWidth.value = state.width;
  }
}

function loadInputsFromState(container) {
  const wrapper = container.querySelectorAll(`.config-dimensions-input-wrapper`);
  if (!wrapper.length) return;

  wrapper.forEach(wrapper => {
    // Clear existing inputs

    const maxHeight = parseFloat(
      wrapper.querySelector('[data-max-height]').dataset.maxHeight
    );

    const maxWidth = parseFloat(
      wrapper.querySelector('[data-max-width]').dataset.maxWidth
    );
    console.log('Max Height:', maxHeight);
    console.log('Max Width:', maxWidth);


    wrapper.querySelectorAll('[data-dimensions-input]').forEach(el => el.remove());

    // Create new inputs based on the state
    appState.forEach((config, index) => {
      const newElement = document.createElement('div');
      newElement.classList.add('controls', 'config-dimensions-input');
      if(appState.length-1 === index) newElement.classList.add('active-input');
      newElement.setAttribute('data-dimensions-input', '');
      newElement.setAttribute('data-index', index);
      newElement.innerHTML = `
        ${appState.length > 1 ? `<div class="remove-button-wrapper"><span class="config-index">${index+1}</span><button class="remove-button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus-icon"><path d="M5 12h14"></path></svg></button></div>`: ``}
        <div id="error-message-${index}" class="error-message"></div>
        <div class="config-dimensions-row">
            <div class="config-dimensions-box" data-max-height="${maxHeight}">
                <label>Höhe 40 - ${maxHeight}</label>
                <div class="input-wrap">
                    <input type="number" class="crop-height" placeholder="Höhe" min="40" max="${maxHeight}" value="${config.height}">
                    <span>cm</span>
                </div>
            </div>
            <div class="config-dimensions-box" data-max-width="${maxWidth}">
                <label>Breite 50 - ${maxWidth}</label>
                <div class="input-wrap">
                    <input type="number" class="crop-width" placeholder="Breite" min="50" max="${maxWidth}" value="${config.width}">
                    <span>cm</span>
                </div>
            </div>
        </div>
      `;
      const referenceNode = wrapper.querySelector(`.add-more-config-pro`);
      if (referenceNode) {
        wrapper.insertBefore(newElement, referenceNode);
      }
    });
  });

  updateAddButtonVisibility(container);
  syncInputsFromState(container);
}

function saveState() {
  sessionStorage.setItem('appState', JSON.stringify(appState));
}

function syncInputsFromState(container) {
  const inputs = container.querySelectorAll('[data-dimensions-input]');

  const displayDimension = container.querySelector("[data-selected-dimension]");
  if (displayDimension) {
    displayDimension.innerHTML = ``;
  }

  inputs.forEach((inputContainer, index) => {
      if (!appState[index]) return;

      const heightInput = inputContainer.querySelector('.crop-height');
      const widthInput  = inputContainer.querySelector('.crop-width');

      if (document.activeElement !== heightInput) {
        heightInput.value = appState[index].height ?? '';
      }

      if (document.activeElement !== widthInput) {
        widthInput.value = appState[index].width ?? '';
      }

      // Update the selected dimensions displayed
      if (displayDimension) {
        const span = document.createElement('span');
        span.setAttribute('data-index', index);
        span.textContent = `${appState[index].height}cm x ${appState[index].width}cm`;
        displayDimension.appendChild(span);
      }
  });

  //render canvas
  renderCanvases(container);

  // Recalculate prices for all inputs after syncing
  calculatePrices();
}

function cmToPixels(cm) {
  //return cm * (IMAGE_DPI / 2.54);
  return (cm / 2.54) * IMAGE_DPI;
}

function setCanvasActiveClass(container){
  const selectedInputIndex = container.querySelectorAll(`.active-input[data-dimensions-input]`);
  const canvasEle = container.querySelectorAll(`.cropped-image-canvas .cropped-image-wrap`);
  if(selectedInputIndex.length){
    if(canvasEle.length) canvasEle.forEach(el => el.classList.remove(`active`));
    if(canvasEle.length){
      selectedInputIndex.forEach(ele => {
        const inputBoxIndex = ele.dataset.index;
        const activeCanvasEle = container.querySelectorAll(`.cropped-image-canvas [data-canvas-index="${inputBoxIndex}"]`);
        if(activeCanvasEle.length) activeCanvasEle.forEach(el => el.classList.add(`active`));
      });
    }
  }
}

function renderCanvases(container) {
  const wrapper = container.querySelector('.cropped-image-canvas');
  if (!wrapper) return;

  // Clear existing canvases
  wrapper.querySelectorAll('.cropped-image-wrap').forEach(el => el.remove());

  // Create and draw a canvas for each item in the state
  appState.forEach((config, index) => {
    const canvas = document.createElement('canvas');
    canvas.classList.add('cropped-image');
    
    //Canvas wrapper ele
    const canvasWrapperEle = document.createElement('div');
    canvasWrapperEle.classList.add('cropped-image-wrap');
    canvasWrapperEle.setAttribute('data-canvas-index', index);
    canvasWrapperEle.appendChild(canvas);
  
    wrapper.appendChild(canvasWrapperEle);

    cropImage(canvas, config.width, config.height, container, index);
  });

  wrapper.removeAttribute(`class`);
  wrapper.classList.add(`product__media`, `cropped-image-canvas`, `canavs-items-${appState.length}`);

  if(appState.length > 1){
    wrapper.classList.add(`multiple_canvas_item`);
  }


  setCanvasActiveClass(container);
}

function updatePrintProperties(index) {
  const printWidthInput  = document.querySelector('input[name="properties[_print_width_cm]"]');
  const printHeightInput = document.querySelector('input[name="properties[_print_height_cm]"]');

  if (!printWidthInput || !printHeightInput) return;
  if (!appState[index]) return;

  printWidthInput.value  = appState[index].width;
  printHeightInput.value = appState[index].height;
}


function cropImage(canvas, cropWidthCm, cropHeightCm, container, index, cropArea = null) {
  const context = canvas.getContext("2d");
  const errorDisplay = container.querySelector(`#error-message-${index}`);
  window.croppedImages = {};


  // Get the input elements for the specific index
  const inputContainer = container.querySelector(`[data-dimensions-input][data-index="${index}"]`);
  if (!inputContainer) {
    console.error(`Input container not found for index ${index}`);
    return;
  }
  const widthInput = inputContainer.querySelector('.crop-width');
  const heightInput = inputContainer.querySelector('.crop-height');

  const minWidth = parseFloat(widthInput.min);
  const maxWidth = parseFloat(widthInput.max);
  const minHeight = parseFloat(heightInput.min);
  const maxHeight = parseFloat(heightInput.max);

  const sourceImage = container.querySelector(".source-image");
  const addToCartBtn = document.querySelectorAll('.config-main-product button[name="add"]');

  // Limit to one digit after decimal while typing
  if (String(cropWidthCm).includes('.') || String(cropHeightCm).includes('.')) {
    const widthParts = String(cropWidthCm).split('.');
    const heightParts = String(cropHeightCm).split('.');
    if (widthParts[1] && widthParts[1].length > 1) {
      cropWidthCm = parseFloat(widthParts[0] + '.' + widthParts[1].slice(0, 1));
    }
    if (heightParts[1] && heightParts[1].length > 1) {
      cropHeightCm = parseFloat(heightParts[0] + '.' + heightParts[1].slice(0, 1));
    }
  }

  const isValid = !isNaN(cropWidthCm) && !isNaN(cropHeightCm) &&
    cropWidthCm >= minWidth && cropWidthCm <= maxWidth &&
    cropHeightCm >= minHeight && cropHeightCm <= maxHeight;

  if (isValid) {
    if (errorDisplay) {
      errorDisplay.textContent = "";
      errorDisplay.classList.remove(`error-active`);
    }
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.removeAttribute('disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `In den Warenkorb`;
      });
    }

    // Update DataLayer
    handleDataLayer(index, 'update');
    
  } else {
    if (errorDisplay) {
      errorDisplay.textContent = `Bitte gib eine gültige Höhe (${minHeight}-${maxHeight} cm) und Breite (${minWidth}-${maxWidth} cm) ein.`;
      errorDisplay.classList.add(`error-active`);
    }
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `Ungültige Höhe oder Breite`;
      });
    }
    return;
  }
  //disabled the ATC btn if atleat one input box error there
  if(container.querySelectorAll(`.error-active`).length){
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `Ungültige Höhe oder Breite`;
      });
    }
  }
  const SCALE = 1; // ← HIGH RES (use 3 for ultra print)

  const cropWidth = cmToPixels(cropWidthCm);
  const cropHeight = cmToPixels(cropHeightCm);

  canvas.width  = cropWidth;
  canvas.height = cropHeight;

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  // sourceImage.onload = function() {
  //   const imageAspectRatio = sourceImage.width / sourceImage.height;
  //   const cropAspectRatio = cropWidth / cropHeight;
  //   let finalWidth, finalHeight;

  //   if (cropAspectRatio > imageAspectRatio) {
  //     finalWidth = sourceImage.width;
  //     finalHeight = finalWidth / cropAspectRatio;
  //   } else {
  //     finalHeight = sourceImage.height;
  //     finalWidth = finalHeight * cropAspectRatio;
  //   }
  //  

  //   if (cropArea) {
  //     const { x, y, width, height } = cropArea;
  //     context.drawImage(sourceImage, x, y, width, height, 0, 0, cropWidth, cropHeight);
  //     if (cropXInput && cropYInput) {
  //       cropXInput.value = x;
  //       cropYInput.value = y;
  //       cropWidthInput.value = cropWidth;
  //       cropHeightInput.value = cropHeight;
  //     }
  //   }
  //   else{
  //     const centerX = sourceImage.width / 2;
  //     const centerY = sourceImage.height / 2;
  //     const cropX = centerX - finalWidth / 2 + dragOffsetX;
  //     const cropY = centerY - finalHeight / 2 + dragOffsetY;

  //     context.drawImage(sourceImage, cropX, cropY, finalWidth, finalHeight, 0, 0, cropWidth, cropHeight);
  //     if (cropXInput && cropYInput) {
  //       cropXInput.value = cropX;
  //       cropYInput.value = cropY;
  //       cropWidthInput.value = cropWidth;
  //       cropHeightInput.value = cropHeight;
  //     }
  //   }

  //   finalImagePreview = canvas.toDataURL("image/png");
  //   //console.log(`finalImagePreview >>`,finalImagePreview)
  // };

  // Trigger image loading by setting the src AFTER the onload handler is attached
  
    if (!sourceImage.complete) {
      sourceImage.onload = () => {
        cropImage(canvas, cropWidthCm, cropHeightCm, container, index);
      };
      return;
    }
    context.clearRect(0, 0, canvas.width, canvas.height);

    const imageWidth  = sourceImage.width;
    const imageHeight = sourceImage.height;

    const imageAspect = imageWidth / imageHeight;
    const cropAspect  = cropWidth / cropHeight;

    const frontendWidth  = sourceImage.naturalWidth;
    const frontendHeight = sourceImage.naturalHeight;

    // 1️⃣ If user manually cropped via Cropper
    const cropXInput      = document.querySelector('input[name="properties[_crop_x]"]');
    const cropYInput      = document.querySelector('input[name="properties[_crop_y]"]');
    const cropWidthInput  = document.querySelector('input[name="properties[_crop_width]"]');
    const cropHeightInput = document.querySelector('input[name="properties[_crop_height]"]');
    const frontendWidthInput  = document.querySelector('input[name="properties[_frontend_width]"]');
    const frontendHeightInput = document.querySelector('input[name="properties[_frontend_height]"]');
    const change_area_btn  = document.querySelector('.change-area-btn');
    let manual_cropping_status = localStorage.getItem('manual_cropping_status');

    if (frontendWidthInput)  frontendWidthInput.value  = frontendWidth;
    if (frontendHeightInput) frontendHeightInput.value = frontendHeight;

    if (savedCropData[index] && manual_cropping_status == 'true') {
      const { x, y, width, height } = savedCropData[index];
      console.log("savedCropData[index]",savedCropData[index]);
      context.drawImage(
        sourceImage,
        x, y, width, height,
        0, 0,
        cropWidth,
        cropHeight
      ); 

      if (cropXInput) {
        cropXInput.value      = Math.round(x);
        cropYInput.value      = Math.round(y);
        cropWidthInput.value  = Math.round(width);
        cropHeightInput.value = Math.round(height);
      }
      
      return;
    }

    // 2️⃣ If user selected FULL size
    if (cropWidthCm == maxWidth && cropHeightCm == maxHeight) {

      context.drawImage(
        sourceImage,
        0, 0,
        imageWidth,
        imageHeight,
        0, 0,
        cropWidth,
        cropHeight
      );

      const fullCrop = {
        x: 0,
        y: 0,
        width: imageWidth,
        height: imageHeight
      };

      savedCropData[index] = fullCrop; // ✅ ADD THIS

      if (cropXInput) {
        cropXInput.value      = fullCrop.x;
        cropYInput.value      = fullCrop.y;
        cropWidthInput.value  = fullCrop.width;
        cropHeightInput.value = fullCrop.height;
      }

      return;
    }
    // 3️⃣ Default → CENTER CROP

    let sx, sy, sWidth, sHeight;

    if (cropAspect > imageAspect) {
      // Crop top/bottom
      sWidth  = imageWidth;
      sHeight = imageWidth / cropAspect;
      sx = 0;
      sy = (imageHeight - sHeight) / 2;
    } else {
      // Crop left/right
      sHeight = imageHeight;
      sWidth  = imageHeight * cropAspect;
      sy = 0;
      sx = (imageWidth - sWidth) / 2;
    }

    context.drawImage(
      sourceImage,
      sx, sy,
      sWidth, sHeight,
      0, 0,
      cropWidth,
      cropHeight
    );

    // 🔥 Save default crop
    const defaultCrop = {
      x: Math.round(sx),
      y: Math.round(sy),
      width: Math.round(sWidth),
      height: Math.round(sHeight)
    };
    console.log("defaultCrop",defaultCrop)
    savedCropData[index] = defaultCrop; // ✅ IMPORTANT
    updatePrintProperties(index);
    syncHiddenProperties();
}

function syncHiddenProperties() {
  const container = document.getElementById('dynamic-config-properties');
  if (!container) return;

  container.innerHTML = ''; // साफ reset

  appState.forEach((config, index) => {
    const crop = savedCropData[index] ?? {
        x: '',
        y: '',
        width: '',
        height: ''
      };

    const fields = {
      [`_crop_x_${index}`]: crop.x ?? '',
      [`_crop_y_${index}`]: crop.y ?? '',
      [`_crop_width_${index}`]: crop.width ?? '',
      [`_crop_height_${index}`]: crop.height ?? '',
      [`_print_width_cm_${index}`]: config.width ?? '',
      [`_print_height_cm_${index}`]: config.height ?? '',
      [`_frontend_width_${index}`]: document.querySelector('.source-image')?.naturalWidth ?? '',
      [`_frontend_height_${index}`]: document.querySelector('.source-image')?.naturalHeight ?? ''
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.value = value;
      container.appendChild(input);
    });
  });
}

function handleInputChange(value, dimension, index, container) {
  // Update the global state with the new value
  appState[index][dimension] = value;
  saveState();
    const canvas = container.querySelector(
    `.cropped-image-wrap[data-canvas-index="${index}"] canvas`
  );

  if (canvas) {
    cropImage(
      canvas,
      appState[index].width,
      appState[index].height,
      container,
      index
    );
  }
  updatePrintProperties(index);
  calculatePrices();
  syncInputsFromState(container);

  if (cropperInstance && !imageAreapopup.classList.contains('hidden')) {
    const activeInput = container.querySelector('[data-dimensions-input].active-input');

    if (activeInput) {
      const cropWidthCm  = parseFloat(activeInput.querySelector(".crop-width").value);
      const cropHeightCm = parseFloat(activeInput.querySelector(".crop-height").value);

      if (cropWidthCm && cropHeightCm) {
        const newAspectRatio = cropWidthCm / cropHeightCm;

        cropperInstance.setAspectRatio(newAspectRatio);

        // Optional: reset crop box to fit new ratio nicely
        cropperInstance.setCropBoxData({
          width: imageAreaPopupImage.width * 0.8,
          height: (imageAreaPopupImage.width * 0.8) / newAspectRatio
        });
      }
    }
  }
  syncHiddenProperties();
}


// function dragMove(e) {

//   let newLeft = e.clientX - dragStartX;

//   let newTop = e.clientY - dragStartY;

//   newLeft = Math.max(0,Math.min(newLeft, imageAreaPopupImage.offsetWidth - draggableArea.offsetWidth));

//   newTop = Math.max(0, Math.min(newTop, imageAreaPopupImage.offsetHeight - draggableArea.offsetHeight));

//   draggableArea.style.left = newLeft + "px";

//   draggableArea.style.top = newTop + "px";

// }



// function dragStop() {

//   document.removeEventListener("mousemove", dragMove);

//   document.removeEventListener("mouseup", dragStop);

// }


// Update DataLayer
function handleDataLayer(configIndex, action = 'update') {
  window.dataLayer = window.dataLayer || [];

  // Find the existing size_inputed event
  let sizeEntry = dataLayer.find(entry => entry.event === 'size_inputed');

  // Create new if it doesn't exist and we're updating
  if (!sizeEntry) {
    if (action === 'update') {
      sizeEntry = {
        event: 'size_inputed',
        size: {}
      };
      dataLayer.push(sizeEntry);
    } else {
      return; // no size_inputed event to remove from
    }
  }

  // Define key for this config
  const key = `${configIndex + 1}_config_input`;

  if (action === 'update') {
    const height = Number(appState[configIndex]?.height || '');
    const width = Number(appState[configIndex]?.width || '');
    sizeEntry.size[key] = { height, width };

  } else if (action === 'remove') {
    if (sizeEntry.size[key]) {
      delete sizeEntry.size[key];

      // Optional: remove the whole size_inputed event if it's empty
      if (Object.keys(sizeEntry.size).length === 0) {
        const index = dataLayer.indexOf(sizeEntry);
        if (index > -1) dataLayer.splice(index, 1);
      }
    }
  }
}


function handleScrollEvent(event) {
  activeStep();
}

function activeStep() {
  let stepCountElement = document.querySelectorAll('.config-main-product .desktop-layout-wrapper [data-config-step]');
  let stepImgElement = document.querySelectorAll('.config-main-product .product__media-wrapper [acive-step]');
  if (!stepCountElement.length && !stepImgElement.length) return;
  stepCountElement.forEach((step, index) => {
    let stepIndex = step.dataset.configStep;
    if (isInViewport(document.querySelector(`[data-config-step="${stepIndex}"]`))) {
      document.querySelectorAll(`.config-main-product [data-config-step]`).forEach(el => el.classList.remove('active'));
      document.querySelectorAll(`.config-main-product .product__media-wrapper [acive-step]`).forEach(el => el.classList.remove('active-step'));
      step.classList.add('active');
      stepImgElement[index].classList.add('active-step');
    }
  });
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}


function calculatePrices() {
  const additionalProdCheckbox = document.querySelectorAll(".config-main-product [data-additional-product-id]");
  const selectedVariantNameEle = document.querySelectorAll(".config-main-product [data-selected-option-title]");
  const finalPriceEle = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-config-sticky-bar-price]");
  const salePriceEle = document.querySelectorAll(".config-main-product [data-final-sale-price], .config-main-product [data-config-sticky-bar-sale-price]");
  const previewBoxAdditionalEle = document.querySelectorAll(".config-main-product [data-selected-addon-product]");
  const finalPreviewPrice = document.querySelectorAll(".config-main-product [data-final-price]");
  const salePreviewPrice = document.querySelectorAll(".config-main-product [data-final-sale-price]");
  const itemConfiguration = {};

  let totalProductPrice = 0;
  let totaloriginalPrice = 0;
  const variantName = selectedVariantNameEle[0]?.dataset.selectedOptionTitle;
  const colorCodeValue = document.querySelector(`.config-main-product [data-product-color-code]`)?.getAttribute('data-product-color-code');
  const variantNameLowerCase = (variantName || '').toLowerCase();

  if (appState.length === 0) {
    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(0));
    }
    return;
  }

  if (appState.length === 0) {
    if (salePriceEle.length) {
      salePriceEle.forEach(element => element.innerHTML = priceFormat.format(0));
    }
    return;
  }

  // Clear all SKU's and  Price from data attribute
  if (selectedVariantNameEle.length) {
    selectedVariantNameEle.forEach(element => {
      [...element.attributes].forEach(attr => {
        if (attr.name.startsWith("data-final-sku") || attr.name.startsWith("data-item-price") || attr.name.startsWith("data-item-opt-price")) {
          element.removeAttribute(attr.name);
        }
      });
    });
  }

  appState.forEach((config, index) => {
    let BUILD_SKU;
    const calcHeightOg = config.height;
    const calcWidthOg = config.width;
    const heightForPrice = Math.round(Number(calcHeightOg));
    const widthForPrice  = Math.round(Number(calcWidthOg));

    const calcHeight = Number(calcHeightOg) / 100;
    const calcWidth = Number(calcWidthOg) / 100;
    const matchedPrice = getMatchedPriceValue(heightForPrice, widthForPrice, variantName);
    const area = calcHeight * calcWidth;
    let BASE, AREA_FACTOR, EXPONENT;
    let productElement = document.querySelector('[data-klassik-area]');
    let klassikArea   = parseFloat(productElement.dataset.klassikArea);
    let deluxeArea    = parseFloat(productElement.dataset.deluxeArea);
    let ecoArea       = parseFloat(productElement.dataset.ecoArea);

    // --- Preisformel Klassik Matt (19.08.2026) -------------------------------
    // Alle Parameter kommen aus dem Theme-Editor ("Product Price Formula").
    // Frueher standen BASE, EXPONENT und die beiden Koeffizienten fest im Code.
    const zahlOderStandard = (wert, standard) => {
      const n = parseFloat(wert);
      return Number.isFinite(n) ? n : standard;
    };
    const klassikBase   = zahlOderStandard(productElement.dataset.klassikBase, 6.5);
    const klassikExp    = zahlOderStandard(productElement.dataset.klassikExp, 0.898);
    const klassikHCoeff = zahlOderStandard(productElement.dataset.klassikHcoeff, 21);
    const klassikWCoeff = zahlOderStandard(productElement.dataset.klassikWcoeff, -5);
    // Materialstufe: ueber dieser Hoehe wird ein zweiter Nutzen angeschnitten (realer
    // Mehrpreis beim Lieferanten 2,92 EUR/m Breite, hier gedaempft weitergegeben).
    const hoehenStufeCm  = zahlOderStandard(productElement.dataset.heightStepCm, 60);
    const stufenZuschlag = zahlOderStandard(productElement.dataset.heightStepSurcharge, 1.31);

    // HCOEFF/WCOEFF ersetzen die frueher fest verdrahteten -5*h und -10*w.
    let HCOEFF = -5, WCOEFF = -10, STUFE_AUFSCHLAG = 0;

    if (variantNameLowerCase.includes('klassik matt')) {
      BASE = klassikBase;
      AREA_FACTOR = klassikArea;
      EXPONENT = klassikExp;
      DISCOUNT = 0.8;
      HCOEFF = klassikHCoeff;
      WCOEFF = klassikWCoeff;
      if (calcHeightOg > hoehenStufeCm) {
        STUFE_AUFSCHLAG = stufenZuschlag * calcWidth;
      }
    } else if (variantNameLowerCase.includes('deluxe glasoptik')) {
      BASE = 10;
      AREA_FACTOR = deluxeArea;
      EXPONENT = 0.75;
      DISCOUNT = 0.7;
    } else if (variantNameLowerCase.includes('eco matt') || variantNameLowerCase.includes('ecomatt')) {
      BASE = 5;
      AREA_FACTOR = ecoArea;
      EXPONENT = 0.8;
      DISCOUNT = 0.8;
    }
    
    const variant_sku =  selectedVariantNameEle[0]?.dataset.selectedOptionSku;
    const skuInput = document.querySelector('input[name="properties[_original_sku]"]');
    if (variant_sku && skuInput) {
      skuInput.value = variant_sku;
    }

    if (matchedPrice) {
      const pricePerSqMeter = matchedPrice;
      console.log("pricePerSqMeter",pricePerSqMeter);
      let price_raw = BASE + AREA_FACTOR * Math.pow(area, EXPONENT) + HCOEFF * calcHeight + WCOEFF * calcWidth + STUFE_AUFSCHLAG;

      let productPrice = 0;     
      let originalPrice = 0;

       if (salePriceEle.length) {
        originalPrice = Math.round(price_raw) + 0.90; 
        productPrice = +(originalPrice * DISCOUNT).toFixed(2); // final price after 20% off
        totalProductPrice += productPrice;
        totaloriginalPrice += originalPrice;  
       }else{
        productPrice = Math.round(price_raw) + 0.90;
        totalProductPrice += productPrice;
       }

      //save individual item price relative to its input value
      if (selectedVariantNameEle.length) {
        selectedVariantNameEle.forEach(element => {
          element.setAttribute(`data-item-opt-price-${index+1}`, (pricePerSqMeter*100).toFixed(2));
          element.setAttribute(`data-item-price-${index+1}`, (productPrice*100).toFixed(2));
          // element.setAttribute(`data-item-price-${index+1}`, (originalPrice*100).toFixed(2));
        });
      }

      //save individual item sku relative to its input value
      if (variantNameLowerCase.includes('matt')) {
        BUILD_SKU = `KRW1_${colorCodeValue || ''}_${calcHeightOg}_${calcWidthOg}`;
      } else if (variantNameLowerCase.includes('glasoptik')) {
        BUILD_SKU = `KRW3_${colorCodeValue || ''}_${calcHeightOg}_${calcWidthOg}`;
      }
      if (selectedVariantNameEle.length) {
        selectedVariantNameEle.forEach(element => element.setAttribute(`data-final-sku-${index+1}`, BUILD_SKU));
      }

      let key = `item-${index+1}`;

      // initialize inner object if not exists
      if (!itemConfiguration[key]) {
        itemConfiguration[key] = {};
      }

      itemConfiguration[key][`item-inputs`] = `${calcHeightOg}cm x ${calcWidthOg}cm`;
      itemConfiguration[key][`item-option-price`] = (pricePerSqMeter*100).toFixed(2);
      itemConfiguration[key][`item-price`] = (productPrice*100).toFixed(2);
      // itemConfiguration[key][`item-price`] = (originalPrice*100).toFixed(2);
      itemConfiguration[key][`item-sku`] = BUILD_SKU;
    }
  });

  //save item configuration
  if (selectedVariantNameEle.length) {
    selectedVariantNameEle.forEach(element => element.setAttribute(`data-item-config`, JSON.stringify(itemConfiguration)));
  }

  const additionalPriceEl = document.querySelector(".config-main-product [data-additional-product-container] .prices");
  const selectedAdditionalProdOgPrice = additionalPriceEl ? Number(additionalPriceEl.dataset.additionalProdOgPrice) : 0;

  if(additionalProdCheckbox.length){
    additionalProdCheckbox.forEach(checkbox => {
      checkbox.checked = false;
      if(!checkbox.checked && previewBoxAdditionalEle.length){
        previewBoxAdditionalEle.forEach(ele => {
          if(ele.closest('li')) ele.closest('li').classList.add('hidden');
        });
      }
    });
  }

  if (salePriceEle.length) {
    let finalPriceWithAddon = totalProductPrice;
    let salePriceWithAddon = totaloriginalPrice;
    if (document.querySelectorAll('.config-main-product [data-additional-product-id]:not(:disabled):checked').length) {
      const additionalPrice = Number(selectedAdditionalProdOgPrice) / 100;
      finalPriceWithAddon += additionalPrice;
      salePriceWithAddon += additionalPrice;
    }

    if (finalPreviewPrice.length) {
      finalPreviewPrice.forEach(element => {
        element.setAttribute('data-final-price', (finalPriceWithAddon * 100).toFixed(2));
      });
    }
    if (salePreviewPrice.length) {
      salePreviewPrice.forEach(element => {
        element.setAttribute('data-final-sale-price', (salePriceWithAddon * 100).toFixed(2));
      });
    }

    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(finalPriceWithAddon);
      });
    }
    if (salePriceEle.length) {
      salePriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(salePriceWithAddon);
      });
    }
  }else{
    let finalPriceWithAddon = totalProductPrice;
    if (document.querySelectorAll('.config-main-product [data-additional-product-id]:not(:disabled):checked').length) {
      const additionalPrice = Number(selectedAdditionalProdOgPrice) / 100;
      finalPriceWithAddon += additionalPrice;
    }

    if (finalPreviewPrice.length) {
      finalPreviewPrice.forEach(element => {
        element.setAttribute('data-final-price', (finalPriceWithAddon * 100).toFixed(2));
      });
    }

    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(finalPriceWithAddon);
      });
    }
  }
  savingComparedToOtherMaterial(variantName);
}

function handleAdditionalProdRadio() {
  let additionalProdCheckbox = document.querySelectorAll(".config-main-product [data-additional-product-id]:not(:disabled)");
  let finalPreviewPrice = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-final-sale-price]");
  let finalPriceEle = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-config-sticky-bar-price]");
  let finalSalePriceEle = document.querySelectorAll(".config-main-product [data-final-sale-price], .config-main-product [data-config-sticky-bar-sale-price]");
  let previewBoxAdditionalEle = document.querySelectorAll(".config-main-product [data-selected-addon-product]");
  if (additionalProdCheckbox.length) {
    additionalProdCheckbox.forEach(checkbox => {
      checkbox.addEventListener('change', function(event) {
        let getFinalPreviewPrice = (Number(document.querySelector(".config-main-product [data-final-price]").getAttribute('data-final-price'))) / 100;
        let getFinalPreviewSalePrice = (Number(document.querySelector(".config-main-product [data-final-sale-price]").getAttribute('data-final-sale-price'))) / 100;
        let getAdditionalPrice = (Number(document.querySelector(".config-main-product [data-final-price]").getAttribute('data-additional-prod-price'))) / 100;
        let currentCheckedPrice = Number(this.closest('.item-container').querySelector('[data-additional-prod-og-price]').getAttribute('data-additional-prod-og-price'));

        const isChecked = this.checked;
        let finalPrice = 0;
        let final_compare_price = 0;
        if (isChecked) {
          if (finalPreviewPrice.length) {
            finalPreviewPrice.forEach(element => element.setAttribute('data-additional-prod-price', currentCheckedPrice));
            if (finalPriceEle.length) {
              finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewPrice + (currentCheckedPrice / 100)));
              finalPrice = getFinalPreviewPrice + (currentCheckedPrice / 100);
            }
            if (finalSalePriceEle.length) {
              finalSalePriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewSalePrice + (currentCheckedPrice / 100)));
              final_compare_price = getFinalPreviewSalePrice + (currentCheckedPrice / 100);
            }
          }
        } else {
          if (finalPreviewPrice.length) {
            finalPreviewPrice.forEach(element => element.setAttribute('data-additional-prod-price', 0));
            if (finalPriceEle.length) {
              finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewPrice));
              finalPrice = getFinalPreviewPrice;
            }
            if (finalSalePriceEle.length) {
              finalSalePriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewSalePrice));
               final_compare_price = getFinalPreviewSalePrice;
            }
          }
        }

        if (this.checked) {
          if (previewBoxAdditionalEle.length) {
            previewBoxAdditionalEle.forEach(ele => {
              if (ele.closest('li')) {
                ele.closest('li').classList.remove('hidden');
              }
            });
          }
          additionalProdCheckbox.forEach(checkbox => checkbox.checked = true);
        } else {
          if (previewBoxAdditionalEle.length) {
            previewBoxAdditionalEle.forEach(ele => {
              if (ele.closest('li')) {
                ele.closest('li').classList.add('hidden');
              }
            });
          }
          additionalProdCheckbox.forEach(checkbox => checkbox.checked = false);
        }
         console.log("finalPrice",finalPrice);
         console.log("final_compare_price",final_compare_price);
          const priceEle = document.querySelector(
          '.config-main-product .final-total-price[data-selected-option-title][data-final-price]'
          );
          const compare_price = document.querySelector(
            '.config-main-product .final-total-sale-price[data-selected-option-title][data-final-sale-price]'
          );
          let total_saving_prices = document.querySelectorAll('.total_saving_price');
          total_saving_prices.forEach((total_saving_price)=>{
            if(total_saving_price && final_compare_price && finalPrice){
              total_saving_price.innerHTML =`Du sparst ${priceFormat.format((final_compare_price -finalPrice ))}`;
            }
          })
      });
    });
  }
}

function savingComparedToOtherMaterial(variantName) {
  let variantNameLowerCase = variantName.toLowerCase();
  let savingTextEle = document.querySelectorAll(".config-main-product [data-price-saved-text]");
  const priceEle = document.querySelector(
    '.config-main-product .final-total-price[data-selected-option-title][data-final-price]'
  );
  const compare_price = document.querySelector(
    '.config-main-product .final-total-sale-price[data-selected-option-title][data-final-sale-price]'
  );
let finalPrice;
let final_compare_price;

  if(priceEle){
  finalPrice = (+priceEle.dataset.finalPrice)/100;
  }
  if(compare_price){
  final_compare_price = (+compare_price.dataset.finalSalePrice)/100;
  }

  let selectedVariantPrice = 0, perSqMeterPrice;

  if (savingTextEle.length) {

    //get total input box price
    priceEle.getAttributeNames().forEach(attr => {
      if (attr.startsWith("data-item-opt-price")) {
        selectedVariantPrice+= Number(priceEle.getAttribute(attr));
      }
    });

    selectedVariantPrice = selectedVariantPrice/100;

    if (variantNameLowerCase.includes('matt')) {
      perSqMeterPrice = 140 * appState.length;
    } else if (variantNameLowerCase.includes('glasoptik')) {
      perSqMeterPrice = 350 * appState.length;
    }
    
    let priceSaving = (finalPrice / selectedVariantPrice) * (perSqMeterPrice - selectedVariantPrice);
    console.log("priceSaving",priceSaving);
    let priceSavingFormat = priceFormat.format(priceSaving);

    savingTextEle.forEach(element => {
      if (variantNameLowerCase.includes('matt')) {
        element.innerHTML = `Du sparst ca. ${priceSavingFormat} gegenüber Aluverbund-Platten.`;
      } else if (variantNameLowerCase.includes('glasoptik')) {
        element.innerHTML = `Du sparst ca. ${priceSavingFormat} gegenüber einer Glas-Rückwand.`;
      }
    });
  }
  let tooltipEle = document.querySelectorAll(".config-main-product .price-saved-info [data-option-title]");
  let tooltipCurrentEle = document.querySelectorAll(`.config-main-product .price-saved-info [data-option-title="${variantName}"]`);
  if (tooltipEle.length) tooltipEle.forEach(el => el.classList.add('hidden'));
  if (tooltipCurrentEle.length) tooltipCurrentEle.forEach(el => el.classList.remove('hidden'));
  let total_saving_prices = document.querySelectorAll('.total_saving_price');
  total_saving_prices.forEach((total_saving_price)=>{
    if(total_saving_price && final_compare_price && finalPrice){
      total_saving_price.innerHTML =`Du sparst ${priceFormat.format((final_compare_price -finalPrice ))}`;
    }
  })
}

function getMatchedPriceValue(height, width, selectedOption) {
  function isInRange(value, rangeStr) {
    const [min, max] = rangeStr.split('-').map(Number);
    return value >= min && value <= max;
  }

  let heightEntry, selectedOptionLowerCase = selectedOption.toLowerCase();
  if (selectedOptionLowerCase == `klassik matt` || selectedOptionLowerCase == `opaco` || selectedOptionLowerCase == `mate` || selectedOptionLowerCase == `mat`) {
    heightEntry = klassikMattPriceGroup.find(item => isInRange(height, item.height));
  } else if (selectedOptionLowerCase == `deluxe glasoptik` || selectedOptionLowerCase == `effetto vetro` || selectedOptionLowerCase == `óptica de vidrio` || selectedOptionLowerCase == `aspect verre`) {
    heightEntry = deluxGlassopticPriceGroup.find(item => isInRange(height, item.height));
  }

  if (heightEntry) {
    const widthEntry = heightEntry.widths.find(item => isInRange(width, item.width));
    if (widthEntry) {
      return widthEntry.value;
    }
  }

  return null;
}

function updateAddButtonVisibility(container) {
  const currentElements = container.querySelectorAll('[data-dimensions-input]');
  if (currentElements.length >= 5) {
    currentElements.forEach(element => {
      const addBtn = element.closest(`.config-dimensions-input-wrapper`)?.querySelector(`#addMoreConfigPro`);
      if(addBtn) addBtn.classList.add(`hidden`);
    });
  } else {
    currentElements.forEach(element => {
      const addBtn = element.closest(`.config-dimensions-input-wrapper`)?.querySelector(`#addMoreConfigPro`);
      if(addBtn) addBtn.classList.remove(`hidden`);
    });
  }
}


if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:block:deselect', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:section:load', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:section:reorder', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
}
